export default __webpack_public_path__ + "static/media/HK_LI.e150bce5.png";